<template>
  <div class="accounts-users-container-outer">
    <div class="accounts-users-container-inner">
      <div>
        <p class="filter-box-heading">{{ headingTitle }}</p>
        <div v-if="showAccountsDropdown" class="account-block">
          <input
              type="radio"
              id="show-account-select"
              value="account"
              v-model="selectionType"
              @change="accountSelected(account)"
          />
          <label class="account-filter-label bold" for="show-account-select"
          >{{ accountDropdownTitle }}
          </label>
          <transition name="slide">
            <v-select
                v-if="selectionType == 'account'"
                :options="accountList"
                :value="account"
                :clearable="false"
                class="v-select-styling"
                label="name"
                placeholder="Select Account"
                @search="onAccountSearch"
                @input="accountSelected"
            >
              <template slot="no-options">
                Type name or space to find accounts
              </template>
            </v-select>
          </transition>
        </div>
        <div v-if="showUsersDropdown" class="user-block">
          <input
              type="radio"
              id="show-user-select"
              value="user"
              v-model="selectionType"
              @change="userSelected(user)"
          />
          <label class="user-filter-label bold" for="show-user-select"
          >{{ userDropdownTitle }}
          </label>
          <transition name="slide">
            <v-select
                v-if="selectionType == 'user'"
                :options="userList"
                placeholder="All Users"
                :value="user"
                :clearable="false"
                class="v-select-styling"
                label="fullname"
                @search="onUserSearch"
                @input="userSelected"
            >
              <template slot="no-options">
                Type name or space to find users
              </template>
            </v-select>
          </transition>
        </div>
        <div v-if="showActiveSessionsFilter" class="active-sessions-block">
          <input
              type="radio"
              id="show-active-sessions"
              value="active-sessions"
              v-model="selectionType"
              @change="showActiveSessions()"
          />
          <label class="user-filter-label bold" for="show-active-sessions"
          >Active sessions
          </label>
        </div>
      </div>
    </div>
    <div class="reset-filter-block">
      <a role="button" class="reset-filter" @click="resetAllFilter">Reset all filters</a>
    </div>
  </div>
</template>

<script>
import {debounce} from "lodash";
import {mapMutations, mapState} from "vuex";
import axios from "axios";

export default {
  data () {
    return {
      selectionType: this.selection,
    };
  },
  props: {
    viewableUsersRoute: {
      type: String,
      default: "",
    },
    selection: {
      type: String,
      default: "user",
    },
    showAccountsDropdown: {
      type: Boolean,
      default: false,
    },
    showUsersDropdown: {
      type: Boolean,
      default: false,
    },
    showActiveSessionsFilter: {
      type: Boolean,
      default: false,
    },
    accountDropdownTitle: {
      type: String,
      default: null,
    },
    userDropdownTitle: {
      type: String,
      default: null,
    },
    headingTitle: {
      type: String,
      default: "",
    },
    myUid: {
      type: String,
      default: "",
    },
    myName: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState("UserDataStore", [
      "user",
      "account",
      "accountList",
      "userList",
    ]),
  },
  methods: {
    ...mapMutations("UserDataStore", [
      "setUser",
      "setAccount",
      "setUserList",
      "setAccountList",
    ]),
    onAccountSearch (search, loading) {
      if (search.length) {
        loading(true);
        this.searchAccounts(loading, search, this);
      }
    },
    accountSelected (value) {
      this.setAccount(value);
      this.$emit("account-selected", value);
    },
    searchAccounts: debounce((loading, search, vm) => {
      axios.get(`/accounts/all?search=${escape(search)}`).then((res) => {
        vm.setAccountList(res.data);
        loading(false);
      });
    }, 350),
    onUserSearch (search, loading) {
      if (search.length) {
        loading(true);
        this.searchUsers(loading, search, this);
      }
    },
    userSelected (value) {
      this.setUser(value);
      this.$emit("user-selected", value);
    },
    searchUsers: debounce((loading, search, vm) => {
      axios
          .get(`${vm.viewableUsersRoute}?search=${escape(search)}`)
          .then((res) => {
            vm.setUserList(res.data);
            loading(false);
          });
    }, 350),
    resetAllFilter () {
      this.selectionType = "user";
      this.setUser({"id": this.myUid, "fullname":this.myName});
      this.$emit("reset-filter");
    },
    showActiveSessions () {
      this.$emit("show-active-sessions");
    }
  },
};
</script>
<style scoped>
.accounts-users-container-inner {
  padding: 15px 32px;
  min-height: 250px;
}

.reset-filter-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 50px;
  padding: 15px 32px;
  border-top: 1px dashed #ccc;;
}

.filter-box-heading {
  color: #333333;
}

a.reset-filter {
  color: #0069AA;
  font-size: 13px;
  padding: 5px;
}

a.reset-filter:hover {
  color: #0069AA;
}

.account-block,
.user-block,
.active-sessions-block {
  margin: 10px 5px;
}
</style>
